import React from 'react';

const NoMatch = (props) => {
    return (
        <h1>Page not found / Seite nicht gefunden</h1>
    );
}

export default NoMatch;